// extracted by mini-css-extract-plugin
export var aside = "ConsultantDetails-module--aside--66363";
export var body = "ConsultantDetails-module--body--f935d";
export var container = "ConsultantDetails-module--container--9e2be";
export var list = "ConsultantDetails-module--list--e74bb";
export var row = "ConsultantDetails-module--row--944a1";
export var sticky = "ConsultantDetails-module--sticky--a872c";